<template>
    <div class="score">
        <div class="score-survey">
            <div class="score-survey-header">
                <h3>Open Source Score</h3>
            </div>

            <div
                class="score-input"
                v-for="(q, i) in questions"
                :key="q.name + '-' + i"
                :class="display(q.name)"
            >
                <div class="number">
                    <span>{{ q.position + 1 }}.</span>
                </div>
                <div class="question">
                    <OSJLabel :theme="theme" :size="size">
                        {{ q.question }}
                    </OSJLabel>

                    <OSJRadioGroup
                        v-if="q.type === 'radio'"
                        :items="q.options"
                        :name="q.name"
                        :theme="theme"
                        :size="size"
                        v-model="answers[q.name]"
                    >
                    </OSJRadioGroup>

                    <OSJCheckboxGroup
                        v-if="q.type === 'checkbox-group'"
                        :limit="3"
                        :columns="2"
                        :items="q.options"
                        :name="q.name"
                        :theme="theme"
                        :size="size"
                        v-model="answers[q.name]"
                    >
                    </OSJCheckboxGroup>
                </div>
            </div>

            <input
                id="a_password_id"
                type="text"
                name="a_password"
                tabindex="-1"
                autocomplete="off"
            />

            <div class="score-input">
                <div class="number">
                    <span>{{ questions.length + 1 }}.</span>
                </div>
                <div class="question">
                    <OSJLabel :theme="theme" :size="size">
                        Email Address
                    </OSJLabel>
                    <OSJInput
                        inputtype="email"
                        placeholdertext="name@mail.com"
                        v-model="answers.useremail"
                    >
                    </OSJInput>
                </div>
            </div>

            <div class="button-container">
                <Btn :route="false" @clicked="e => postForm(false)"
                    >Submit Survey</Btn
                >
            </div>
        </div>

        <div v-if="status === st.MISSING" class="overlay">
            <div class="inset">
                <!-- <div class="image"></div> -->
                <p>
                    Thank you so much for completing the survey, but we won't be
                    able to
                    <strong>send you your score and eductational links</strong>
                    without your email address. Add your email address now or
                    submit without it. We're just glad you took the survey.
                    Thanks!
                </p>

                <div v-if="overlayEmailOpen">
                    <OSJLabel :theme="theme" :size="size">
                        Email Address
                    </OSJLabel>
                    <OSJInput
                        inputtype="email"
                        placeholdertext="name@mail.com"
                        v-model="answers.useremail"
                    >
                    </OSJInput>
                </div>

                <div class="button-container-overlay">
                    <div
                        class="overlay-email-open"
                        @click="e => postForm(true)"
                        :class="{ email: overlayEmailOpen }"
                    >
                        Submit Survey
                    </div>
                    <Btn
                        :route="false"
                        v-if="!overlayEmailOpen"
                        @clicked="openOverlayEmail"
                        >Add Email</Btn
                    >
                </div>
            </div>
        </div>

        <div v-if="status === st.SENDING" class="overlay">
            <div class="inset">
                <!-- <div class="image"></div> -->
                <p>Calculating score...</p>
            </div>
        </div>

        <div v-if="status === st.ERROR" class="overlay">
            <div class="inset">
                <!-- <div class="image"></div> -->
                <p>Whoops! Something went wrong.</p>
                <router-link to="/">Back Home</router-link>
                <router-link to="/resources">Educational Resource</router-link>
            </div>
        </div>

        <div v-if="status === st.COMPLETE" class="overlay">
            <div class="inset">
                <div class="image">
                    <span>{{ score }}</span>
                </div>

                <h3>Thanks for submitting!</h3>
                <p v-if="percentile != null">You're score is {{ score }} out of 100 points and you did better than {{percentile}}% of {{surveysTaken}} surveys taken.</p>
                <router-link to="/">Back Home</router-link>
                <router-link to="/resources">Educational Resource</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import OSJCheckboxGroup from "@/components/OSJCheckboxGroup";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

import OSJRadioGroup from "@/components/OSJRadioGroup";
import OSJInput from "@/components/OSJInput";
import OSJLabel from "@/components/OSJLabel";
import Btn from "@/components/Btn";
import { survey } from "@/data/survey";
import axios from "axios";

const status = {
    UNFILLED: 0,
    MISSING: 1,
    FILLED: 2,
    REJECTED: 3,
    SENDING: 4,
    ERROR: 5,
    COMPLETE: 6
};

export default {
    name: "Survey",
    components: {
        OSJRadioGroup,
        OSJCheckboxGroup,
        OSJInput,
        OSJLabel,
        Btn
    },
    data() {
        const questions = survey.questions;
        const answers = {
            version: survey.version,
            useremail: null,
            honey: null
        };
        questions.forEach(q => {
            answers[q.name] = q.type === "checkbox-group" ? [] : null;
        });

        return {
            percentile: null,
            surveysTaken: null,
            theme: "dark",
            size: "large",
            rt:
                "https://us-central1-opensourcejobs-db.cloudfunctions.net/sendMandrillEmailTemplate",

            status: status.UNFILLED,
            overlayEmailOpen: false,
            questions,
            answers
        };
    },
    computed: {
        st() {
            return status;
        },
        score() {
            const r = (a, b) => a + b;
            const v = q => q.tier;
            const min = 100 / this.questions.map(v).reduce(r);

            const raw = this.questions.map(el => {
                const ll = el.options.length;
                if (el.tier > 0) {
                    const m = (min * el.tier) / (ll - 1);
                    for (let i = 0; i < ll; i++) {
                        if (el.options[i].value === this.answers[el.name]) {
                            return m * i;
                        }
                    }
                }
                return 0;
            });
            return Math.round(raw.reduce(r));
        },
        request() {
            return {
                template_name: "OS_Score_Email",
                template_content: [
                    {
                        name: "name",
                        content: "content"
                    }
                ],
                message: {
                    html: "<p>Jobs go here!</p>",
                    subject: "Open Source Score: " + this.score,
                    from_email: "donotreply@opensourcejobs.com",
                    from_name: "Open Source Score",
                    to: [
                        {
                            email: this.answers.useremail,
                            type: "to"
                        }
                    ],
                    headers: {
                        "Reply-To": "donotreply@opensourcejobs.com"
                    },
                    merge_vars: [
                        {
                            rcpt: this.answers.useremail,
                            vars: [
                                {
                                    name: "OSSCORE",
                                    content: this.score
                                },
                                {
                                    name: "OSSPERCENTILE",
                                    content: this.percentile
                                },
                                {
                                    name: "OSSSURVEYSTAKEN",
                                    content: this.surveysTaken
                                }
                            ]
                        }
                    ]
                }
            };
        }
    },
    methods: {
        openOverlayEmail({ event }) {
            console.log(event);
            event.preventDefault();
            this.overlayEmailOpen = true;
        },
        display(val) {
            const value = this.answers[val];
            return {
                answered: Array.isArray(value)
                    ? value.length > 0
                    : value !== null
            };
        },
        showSurvey() {
            event.preventDefault();
            this.$store.commit("assent", true);
        },
        postForm(force) {
            event.preventDefault();

            if (force) {
                // Force the form to submit without an email address
                this.status = status.FILLED;
            } else {
                this.status =
                    this.answers.useremail === null
                        ? status.MISSING
                        : status.FILLED;
                if (this.status === status.MISSING) {
                    return false;
                }
            }

            // Form is sending
            this.status = status.SENDING;

            // Get valid token
            firebase
                .auth()
                .currentUser.getIdToken(true)
                .then(idToken => this.postJobDetails(idToken))
                .catch(() => {
                    console.log("idError");
                    this.status = status.ERROR;
                });
        },
        postJobDetails(idToken) {
            // Post job details to firebase
            const answers = this.answers;
            answers.score = this.score;

            const data = firebase.database().ref("opensourcescores");

            axios
                .post(this.$store.state.fb + idToken, this.answers)
                .then(() => {
                    const scores = [];

                    data
                        .once("value", snap => {
                            snap.forEach(childsnap => {
                                scores.push(childsnap.val().score);
                            });

                            scores.sort((a, b) => b - a).reverse();
                            this.surveysTaken = scores.length;
                            this.percentile = Math.floor((scores.indexOf(this.score) / this.surveysTaken) * 100);
                            
                            // fire off email
                            console.log('firing email')
                            this.answers.useremail ? this.send() : this.finish();
                        })
                    
                })
                .catch(() => (this.status = status.ERROR));
        },
        send() {
            // Send the transaction email from Mandrill
            console.log('sending email')
            axios
                .post(this.rt, this.request)
                .then(() => this.finish())
                .catch(() => (this.status = status.ERROR));
        },
        finish() {
            // Display the completion screen
            this.status = status.COMPLETE;
        }
    }
};
// axios
//     .get(
//         "https://opensourcejobs-db.firebaseio.com/opensourcescores.json?&auth=" +
//             idToken
//     )
//     .then(({ data }) => {
//         const scores = [];
//         for (const el in data) {
//             console.log();
//             scores.push(data[el].score);
//         }
//         scores.sort((a, b) => b - a).reverse();
//         // console.log(scores, this.score);
//         console.log(
//             Math.floor(
//                 (scores.indexOf(this.score) /
//                     scores.length) *
//                     100
//             ) + "%"
//         );
//     })
//     .catch(err => console.log(err));
</script>

<style lang="scss" scoped>
@import "../scss/vars";

.btn {
    font-size: 1.6rem;
    margin-left: 1rem;
}

#a_password_id {
    position: fixed;
    left: 200%;
    width: 1px;
    height: 1px;
    opacity: 0;
    display: none;
}
.score {
    margin-bottom: 20rem;
    &-survey {
        padding: 0;
        margin: 0;
    }
    &-input {
        display: flex;
        background-color: white;
        padding: 1rem 2rem;
        margin-bottom: 1rem;
        border-radius: 4px;

        label {
            padding-bottom: 1rem;
        }
    }
}
.question {
    flex-grow: 1;
}

.number {
    flex-shrink: 0;
    font-weight: 700;
    color: $pale-gray;
    display: flex;
    font-size: 1.8rem;
    margin-right: 1rem;

    .answered & {
        color: $dark-green;
    }

    @media screen and (min-width: $b1) {
        align-items: center;
        margin-right: 3rem;
        padding-right: 3rem;
        border-right: 1px solid #eee;
        font-size: 2rem;
    }
}

.button-container {
    text-align: right;
    padding-top: 2rem;

    &-overlay {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: right;
        padding-top: 2rem;
    }
}

.overlay-email-open {
    color: $red;
    font-weight: 700;
    text-decoration: none;
    padding: 1rem 2rem;
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
        color: $blue;
    }

    &.email {
        background-color: $red;
        color: white;
        border-radius: 4px;

        &:hover {
            background-color: $blue;
        }
    }
}

.score-survey-header {
    text-align: center;
    width: 80%;
    margin: 0 auto;

    h3 {
        color: $red;
        font-weight: 900;
        font-size: 4rem;
        line-height: 4rem;
        text-transform: uppercase;
        padding: 1rem 0 2rem 0;

        @media screen and (min-width: $b1) {
            padding: 2rem 0 4rem 0;
            font-size: 6rem;
            line-height: 6rem;
        }
    }
}

.overlay {
    position: fixed;
    padding: 2rem;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 100000;
    -webkit-backface-visibility: hidden;
    background-color: rgba(0, 0, 0, 0.85);
    h3 {
        font-weight: 900;
        font-size: 2.4rem;
        line-height: 1;
        margin: 0.4rem 0;
    }
    .inset {
        max-width: $b1 * 0.75;
        flex-basis: 100%;
        background: white;
        padding: 3rem;
        border-radius: 4px;
        overflow: hidden;
        margin: 0 auto;
        text-align: center;

        p {
            border-bottom: 1px solid #eee;
            padding: 1rem 0;
            margin-bottom: 2rem;
        }

        > a {
            display: inline-block;
            padding: 0.5rem 1rem;
        }
    }

    .image {
        padding-top: 80%;
        background-color: $red;
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        span {
            // background: green;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            align-items: center;
            justify-content: center;
            color: white;

            display: flex;
            font-size: 10rem;
            font-weight: 900;
            transform: rotate(-20deg) scale(2) skew(-20deg);
            letter-spacing: 0.01rem;

            @media screen and (min-width: $b1 / 2) {
                font-size: 15rem;
            }

            @media screen and (min-width: $b1) {
                font-size: 20rem;
            }
        }
    }
}
</style>
